<template>
    <div class="selector">
        <div class="header">
            <div class="title">管线养护</div>
        </div>

        <div class="query">
            <div class="queryInfo">
                <InputField labelWidth="0" style="margin: 0.5rem 0.5rem;width:25%;" type="text" id="name" v-model="queryForm.name" placeholder="巡查人"/>
                <SelectField labelWidth="0" style="margin: 0.1rem 0.1rem 0.1rem 0;padding:0 0.2rem;width:25%;" :options="typeList" v-model="queryForm.type" id="type" placeholder="巡查类型"/>
                <RangePickerField labelWidth="0" style="margin: 0.1rem 0.1rem 0.1rem 0;padding:0 0.2rem;width:30%;" v-model="queryForm.date" :placeholder="['开始时间', '结束时间']" :disabled="false"/>
                <a-space>
                    <ButtonField text="查询" @click="query" secondary />
                    <ButtonField text="重置" primary @click="reset"/>
                </a-space>
            </div>
            <div>
                <ButtonField text="新增巡查信息" @click="add" secondary />
            </div>
        </div>

        <div class="table">
            <Tablelist
                    style="margin-top: 1rem"
                    :showCheckbox="false"
                    :list="list"
                    :columns="tableColumns"
            >
            </Tablelist>

        </div>
        <Modal v-if="visible" v-model="visible"
               :visible="visible"
               title="创建养护计划"
               :showFooter="false"
               :overlayOpacity="0.5"
               contentWidth="30%"
               @update:visible="visible = $event">
            <form @submit.prevent="handleSubmit">
                <div style="width: 90%;margin: auto;">
                    <div class="form-group-list">
                        <InputField labelWidth="30%" style="margin: 0.5rem 0.2rem;" label="巡查人" type="text" id="name" v-model="form.name" required placeholder="巡查人"/>
                        <SelectField labelWidth="32%" style="margin: 0.5rem 0.2rem;"  label="巡查类型" required :options="typeList" v-model="queryForm.type" id="type" placeholder="巡查类型"/>
                    </div>
                    <div class="form-group-list">
                        <SelectField labelWidth="32%" style="margin: 0.5rem 0.2rem;"  label="巡查方式" required :options="methodList" v-model="form.method" id="type" placeholder="巡查方式"/>
                        <TextareaField :value="form.detail" required labelWidth="30%" style="margin: 0.5rem 0.2rem" label="问题描述"/>
                    </div>
                    <div class="right" style="margin: 1rem 0 0 0;">
                        <a-space>
                            <ButtonField text="关闭" @click="cancel" secondary />
                            <ButtonField text="保存" primary @click="handleSubmit"/>
                        </a-space>
                    </div>
                </div>
            </form>
        </Modal>

    </div>
</template>

<script>

export default {
    data() {
        return {
            queryForm: {},
            loading: false,
            current: 1,
            pageSize: 10,
            methodList:[{value:'1',name:'步行'}],
            typeList:[{value:'1',name:'日常巡查'}],
            statusList:[{value:1,name:'待养护'},{value:2,name:'养护中'},{value:3,name:'养护完成'}],
            list: [
                {
                    name: "黄强",
                    type: "日常巡查",
                    method: "步行",
                    remarks: "--",
                    date: "2022-06-22 12:31:20",
                },
                {
                    name: "黄强",
                    type: "日常巡查",
                    method: "步行",
                    remarks: "--",
                    date: "2022-06-22 12:31:20",
                },
                {
                    name: "黄强",
                    type: "日常巡查",
                    method: "步行",
                    remarks: "--",
                    date: "2022-06-22 12:31:20",
                },
                {
                    name: "黄强",
                    type: "日常巡查",
                    method: "步行",
                    remarks: "--",
                    date: "2022-06-22 12:31:20",
                },
                {
                    name: "黄强",
                    type: "日常巡查",
                    method: "步行",
                    remarks: "--",
                    date: "2022-06-22 12:31:20",
                },
            ],
            total: 0,
            form: this.$form.createForm(this),
            visible: false,
            tableColumns:[
                {
                    key: 'name',
                    title: '巡查人',
                    field: 'name',
                    infotype: 'text'
                },
                {
                    key: 'type',
                    title: '巡查类型',
                    field: 'type',
                    infotype: 'text',
                },
                {
                    key: 'method',
                    title: '巡查方式',
                    field: 'method',
                    infotype: 'text',
                },
                {
                    key: 'remarks',
                    title: '问题描述',
                    field: 'remarks',
                    infotype: 'text',
                },
                {
                    key: 'date',
                    title: '创建时间',
                    field: 'date',
                    infotype: 'text',
                }]
        };
    },

    methods: {
        query() {},
        reset() {
            this.queryForm = {};
        },
        onChange(pagination) {
            this.current = pagination.current;
            this.pageSize = pagination.pageSize;
        },
        editText() {},
        deleteText() {},

        add() {
            this.visible = true;
        },
        cancel() {
            this.visible = false;
        },

        handleSubmit(e) {
            e.preventDefault();
            this.form.validateFields((err, values) => {
                if (!err) {
                    console.log("values", values);
                    this.cancel();
                }
            });
        },
    },
};
</script>


<style lang="less" scoped>
.selector {
  position: fixed;
  top: 11vh;
  left: 17vw;
  right: calc(1vw + 140px);
  z-index: 99;
  background-color: var(--default-bgcolor);

  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.16);
  border-radius: 10px;
  border: 1px solid #065645;
  & > .header {
    background-color:rgba(0, 0, 0, 0.9);
    color: #00ff96;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 0 0.5rem 1rem;
    line-height: 4vh;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    font-size: 1rem;
  }

  .query {
    padding: 2vh 1vw 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .table {
    padding: 2vh 1vw;
  }
  .queryInfo{
    display: flex;
    justify-content: space-around;
  }
}
</style>